import type { EmbarcacaoThrustersField } from "@/modules/embarcacoes";
import { formatDetailDate } from "../../../detail-format/detail-format";

export const THRUSTERS_ID = "thrusters";
export const THRUSTERS_TITLE = "Thrusters";
export const THRUSTERS_TEST_ID = "embarcacao-thrusters";
export const THRUSTERS_LOADING_MESSAGE = "Carregando os Thrusters da embarcação...";

/** Padrão global de estado vazio do Hub para a embarcação sem thrusters. */
export const THRUSTERS_EMPTY_STATE = {
  title: "Nenhuma informação de Thrusters disponível",
  description: "Assim que houver thrusters desta embarcação, eles aparecerão nesta seção.",
};

export interface ThrustersColumnDefinition {
  readonly field: EmbarcacaoThrustersField;
  readonly header: string;
  readonly format?: (value: string) => string;
}

/** As 6 colunas da tabela, na ordem da HU e do protótipo; a unidade de medida acompanha o cabeçalho. */
export const THRUSTERS_COLUMNS: ThrustersColumnDefinition[] = [
  { field: "thruster", header: "Thruster" },
  { field: "quantidade", header: "Quantidade" },
  { field: "marca", header: "Marca" },
  { field: "numeroSerie", header: "Número de série" },
  { field: "potencia", header: "Potência (kW)" },
  { field: "atualizacaoThrusters", header: "Data Atualização", format: formatDetailDate },
];

/** A tabela rola na horizontal abaixo desta largura (RN003). */
export const THRUSTERS_TABLE_MIN_WIDTH = "48rem";
